import {
    AddAssistanceApplicationInformationRequestViewModel,
    AssistanceApplicationReviewClient,
    AssistanceApplicationInformationRequestViewModel, AssistanceApplicationDenialReason, DenyReviewAssistanceApplicationViewModel,
} from './api.client';
import {NotificationService} from './NotificationService';
import {inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, share, tap} from 'rxjs/operators';
import {getMessageFromException} from '../utilities/Util';

@Injectable({
    providedIn: 'root'
})
export class AssistanceApplicationReviewService {

    private _notificationService = inject(NotificationService);
    private _infoRequestClient = inject(AssistanceApplicationReviewClient);

    addInformationRequest(infoRequest: AddAssistanceApplicationInformationRequestViewModel):
        Observable<AssistanceApplicationInformationRequestViewModel> {
        const request = this._infoRequestClient
            .addInformationRequest(infoRequest).pipe(share());
        this._notificationService.showSuccess('Attempting to update information request.');
        request
            .pipe(
                tap(_ => this._notificationService.showSuccess('Application information request successfully updated.')),
                catchError(err => {
                    console.error(err);
                    this._notificationService.showError(getMessageFromException(err));
                    return of(); // Return fallback data
                })
            );
        return request;
    }

    passReviewApplication(applicationId: string, additionalInfo?: string): Observable<void> {
        this._notificationService.showSuccess('Attempting to pass review.');
        const request = this._infoRequestClient.passReviewAssistanceApplication(applicationId, additionalInfo).pipe(share());
        request
            .pipe(
                tap(_ => this._notificationService.showSuccess('Application successfully passed review.')),
                catchError(err => {
                    console.error(err);
                    this._notificationService.showError(getMessageFromException(err));
                    return of(); // Return fallback data
                })
            );
        return request;
    }

    addAgencyInformationRequest(infoRequest: AddAssistanceApplicationInformationRequestViewModel):
        Observable<AssistanceApplicationInformationRequestViewModel> {
        const request = this._infoRequestClient
            .addAgencyInformationRequest(infoRequest).pipe(share());
        this._notificationService.showSuccess('Attempting to update information request.');
        request
            .pipe(
                tap(_ => this._notificationService.showSuccess('Application information request successfully updated.')),
                catchError(err => {
                    console.error(err);
                    this._notificationService.showError(getMessageFromException(err));
                    return of(); // Return fallback data
                })
            );
        return request;
    }

    passAgencyReviewApplication(applicationId: string, additionalInfo?: string): Observable<void> {
        this._notificationService.showSuccess('Attempting to pass review.');
        const request = this._infoRequestClient.passAgencyReviewAssistanceApplication(applicationId, additionalInfo).pipe(share());
        request
            .pipe(
                tap(_ => this._notificationService.showSuccess('Application successfully passed review.')),
                catchError(err => {
                    console.error(err);
                    this._notificationService.showError(getMessageFromException(err));
                    return of(); // Return fallback data
                })
            );
        return request;
    }

    denyReviewApplication(applicationId: string, denialReason: AssistanceApplicationDenialReason, otherReason: string): Observable<void> {
        this._notificationService.showSuccess('Attempting to deny review.');

        const denyReviewViewModel = DenyReviewAssistanceApplicationViewModel.fromJS({
            applicationId,
            denialReason,
            otherReason
        });

        const request = this._infoRequestClient.denyReviewAssistanceApplication(denyReviewViewModel).pipe(share());
        request
            .pipe(
                tap(_ => this._notificationService.showSuccess('Application successfully denied in review.')),
                catchError(err => {
                    console.error(err);
                    this._notificationService.showError(getMessageFromException(err));
                    return of(); // Return fallback data
                })
            );
        return request;
    }
}
